'use client'
import axios from '@/utils/axiosInterceptor';

const ctrl = {};

ctrl.getDatos = async (cedularuc) => {
    return axios.get('/api/catastro/persona/cedularuc',{
        params: {
            cedularuc
        }
    })
};

ctrl.getRecuperaTitulo = async (cedula) => {
    return axios.get('/api/dinardap/recuperartitulos',{
        params: {
            cedula
        }
    })
};

export default ctrl;